import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=47108f1c&"
import script from "./goodsInfo.vue?vue&type=script&lang=js&"
export * from "./goodsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47108f1c')) {
      api.createRecord('47108f1c', component.options)
    } else {
      api.reload('47108f1c', component.options)
    }
    module.hot.accept("./goodsInfo.vue?vue&type=template&id=47108f1c&", function () {
      api.rerender('47108f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Order/goodsInfo.vue"
export default component.exports